import styled from 'styled-components';

export const DrawerOverlay = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: ${props => props.open ? 'block' : 'none'};
  cursor: default;
`;

export const DrawerContainer = styled.div<{ open: boolean; width?: string }>`
  position: fixed;
  top: 0;
  right: 0;
  width: ${props => props.width || '400px'};
  height: 100vh;
  background: #FFFFFF;
  z-index: 1000;
  transform: translateX(${props => props.open ? '0' : '100%'});
  transition: transform 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  max-width: 100vw;
  box-sizing: border-box;
  overflow-x: hidden;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100dvh;
  }

  @media screen and (max-width: 1000px) and (min-width: 769px) {
    width: ${props => props.width || '320px'};
  }
`;

export const DrawerHeader = styled.div`
  padding: 24px 24px 16px 24px;
  border-bottom: 1px solid #E0E0E0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 500;
    color: #333;
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  color: #666;
  transition: all 0.2s ease;

  &:hover {
    background: #F5F5F5;
    color: #333;
  }

  &:active {
    background: #E0E0E0;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const DrawerContent = styled.div<{ hasHeader?: boolean; hasFooter?: boolean }>`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  ${props => !props.hasHeader && 'padding-top: 32px;'}
  ${props => !props.hasFooter && 'padding-bottom: 32px;'}

  .entry {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    height: 40px;
    padding-right: 12px;
    border-radius: 4px;

    :hover {
      background-color: #F5F5F5;
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  .entryName {
    font-size: 0.9rem;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    text-align: left;
    background: none;
    border: none;
    width: 100%;
    color: #333;
    margin-left: 5px;
    cursor: pointer;

    &.disabled {
      color: #BDBDBD;
      cursor: not-allowed;
    }
  }
`;

export const DrawerFooter = styled.div`
  padding: 24px;
  border-top: 1px solid #E0E0E0;
  display: flex;
  gap: 12px;
  background: #FFFFFF;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    padding-bottom: calc(24px + env(safe-area-inset-bottom, 0px));
  }
`;

export const FooterButton = styled.button<{ variant: 'outline' | 'primary' }>`
  flex: 1;
  height: 48px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: ${props => props.variant === 'outline' ? '1px solid #E0E0E0' : 'none'};
  background: ${props => props.variant === 'outline' ? '#FFFFFF' : '#89BD23'};
  color: ${props => props.variant === 'outline' ? '#666' : '#FFFFFF'};

  &:hover {
    ${props => props.variant === 'outline'
    ? 'background: #F5F5F5; border-color: #BDBDBD;'
    : 'background: #7AA61F;'
  }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
